/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_Effort_Limit_TimeInputs */

const en_us2_workout_quick_effort_limit_time = /** @type {(inputs: Workout_Quick_Effort_Limit_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nothing left`)
};

const pt_br2_workout_quick_effort_limit_time = /** @type {(inputs: Workout_Quick_Effort_Limit_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nada mais`)
};

const es_419_workout_quick_effort_limit_time = /** @type {(inputs: Workout_Quick_Effort_Limit_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no quedaba nada`)
};

const pt_pt2_workout_quick_effort_limit_time = /** @type {(inputs: Workout_Quick_Effort_Limit_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nada mais`)
};

const fr_fr2_workout_quick_effort_limit_time = /** @type {(inputs: Workout_Quick_Effort_Limit_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`plus rien`)
};

const de_de2_workout_quick_effort_limit_time = /** @type {(inputs: Workout_Quick_Effort_Limit_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nichts übrig`)
};

const it_it2_workout_quick_effort_limit_time = /** @type {(inputs: Workout_Quick_Effort_Limit_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`niente di più`)
};

/**
* | output |
* | --- |
* | "nothing left" |
*
* @param {Workout_Quick_Effort_Limit_TimeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_effort_limit_time = /** @type {((inputs?: Workout_Quick_Effort_Limit_TimeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_Effort_Limit_TimeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_effort_limit_time(inputs)
	if (locale === "es-419") return es_419_workout_quick_effort_limit_time(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_effort_limit_time(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_effort_limit_time(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_effort_limit_time(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_effort_limit_time(inputs)
	return en_us2_workout_quick_effort_limit_time(inputs)
});
export { workout_quick_effort_limit_time as "workout-quick.effort_limit_time" }